import type { Shadows } from '@mui/material/styles';

const DROP_SHADOW_LEVEL_1 = '0px 2px 4px rgba(0, 0, 0, 0.32)';
const DROP_SHADOW_LEVEL_2 = '0px 6px 10px rgba(0, 0, 0, 0.4), 0px 2px 4px rgba(0, 0, 0, 0.24)';
const DROP_SHADOW_LEVEL_3 = '0 0 0 1px rgba(255, 255, 255, 0.08)';

const shadows: Shadows = [
  'none',
  DROP_SHADOW_LEVEL_1,
  DROP_SHADOW_LEVEL_2,
  DROP_SHADOW_LEVEL_3,
  '0 0 1px 0 rgba(0,0,0,0.5), 0 3px 4px -2px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 4px 6px -2px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 4px 6px -2px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 4px 8px -2px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 5px 8px -2px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 6px 12px -4px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 7px 12px -4px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 6px 16px -4px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 7px 16px -4px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 8px 18px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 9px 18px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 10px 20px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 11px 20px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 12px 22px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 13px 22px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 14px 24px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 16px 28px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 18px 30px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 20px 32px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 22px 34px -8px rgba(0,0,0,0.45)',
  '0 0 1px 0 rgba(0,0,0,0.5), 0 24px 36px -8px rgba(0,0,0,0.45)',
];

export default shadows;
